import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// Build v20260603-cdn-cache-bust - IBA Connect (PWA enabled)
// 2026-06-03: Cambio de bundle hash forzado para esquivar el cache poisoning
// del CDN de producción. El CDN tenía /static/js/main.05ba1c1e.js cacheado
// con respuesta text/html (6.6KB del index.html fallback de un deploy
// fallido anterior). Browsers rechazaban ejecutar el "JS" porque su MIME
// type era text/html → pantalla blanca total en todos los dispositivos.
// Con este cambio, webpack genera un hash de bundle nuevo → URL nueva → CDN
// la sirve fresca desde origen → app funciona.

// Stamp de build runtime — NO es un comentario, terser NO lo elimina. Esto
// garantiza que el contenido del bundle cambie SIEMPRE entre deploys y
// webpack produzca un hash de chunk diferente al envenenado en CDN.
window.__IBA_BUILD_STAMP__ = '20260617-0240-cdn-rescue-v2-tz';
console.log('[IBA Connect] Build:', window.__IBA_BUILD_STAMP__);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registro del Service Worker para soporte PWA (Add to Home Screen).
// El SW es network-first puro (no cachea) para evitar pantalla blanca por
// bundle viejo, pero queda registrado de forma permanente — requisito
// mínimo para que el navegador ofrezca instalar la app.
//
// IMPORTANTE: NO hacer auto-reload en `controllerchange` aunque sea tentador.
// Convive con el killswitch de index.html, el watchdog de React, y la
// re-registración que hace OneSignal SDK con su propio `serviceWorkerPath`.
// Si auto-recargás en cada controllerchange, esos 4 actores se gatillan
// entre sí y producen loops de 10-15 reloads en producción (bug confirmado
// 2026-06-02). La actualización se hace SIEMPRE vía el banner manual del
// VersionChecker — el usuario toca "Actualizar Ahora" y ahí se limpia todo.
//
// Lo que SÍ hacemos:
//   1. Cada build cambia el byte content del SW (SW_VERSION bumpeada por
//      update-version.js) → el navegador detecta diff e instala el SW nuevo
//      en background. La página actual sigue con el SW viejo hasta que el
//      usuario decide actualizar.
//   2. Forzamos `registration.update()` cuando el usuario vuelve al app
//      (visibilitychange / focus) → así el banner "Actualizar Ahora" puede
//      aparecer apenas hay nueva versión disponible.
if ('serviceWorker' in navigator && typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        // Si hay una versión nueva esperando, NO la activamos automáticamente
        // acá — dejamos que el usuario decida desde el banner manual.

        // Forzar check de updates cuando el usuario vuelve al app
        // (clave en PWA mobile donde la pestaña queda viva por horas).
        const checkForUpdate = () => {
          try { reg.update(); } catch (e) { /* ignore */ }
        };
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') checkForUpdate();
        });
        window.addEventListener('focus', checkForUpdate);
        // Check periódico cada 15 minutos como red de seguridad
        setInterval(checkForUpdate, 15 * 60 * 1000);
      })
      .catch(() => {
        // Si el registro falla, la app sigue funcionando sin PWA
      });
  });
}
